export default __webpack_public_path__ + "fonts/CiscoSansRegularOblique-webfont.eot";